import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4fb10d4c&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=4fb10d4c&prod&scoped=true&lang=css"
import style1 from "./order.vue?vue&type=style&index=1&id=4fb10d4c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb10d4c",
  null
  
)

export default component.exports